import { jsx as C } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ C(
  "path",
  {
    d: "M18.3199 7.09436L20.7071 4.70711C21.0976 4.31658 21.0976 3.68342 20.7071 3.29289C20.3166 2.90237 19.6834 2.90237 19.2929 3.29289L16.9056 5.68014C15.551 4.62708 13.8487 4 12 4C7.58172 4 4 7.58172 4 12C4 13.8487 4.62708 15.551 5.68014 16.9056L3.29289 19.2929C2.90237 19.6834 2.90237 20.3166 3.29289 20.7071C3.68342 21.0976 4.31658 21.0976 4.70711 20.7071L7.09436 18.3199C8.44904 19.3729 10.1513 20 12 20C16.4183 20 20 16.4183 20 12C20 10.1513 19.3729 8.44904 18.3199 7.09436ZM15.4765 7.10925C14.4957 6.41079 13.2958 6 12 6C8.68629 6 6 8.68629 6 12C6 13.2958 6.41079 14.4957 7.10925 15.4765L15.4765 7.10925ZM8.52347 16.8907L16.8907 8.52347C17.5892 9.50428 18 10.7042 18 12C18 15.3137 15.3137 18 12 18C10.7042 18 9.50428 17.5892 8.52347 16.8907Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
export {
  r as default
};
